<template>
  <div class="content-scoll">
     <div class="teacher-area">
      <div class="teacher">
      <div class="scroll">
        <card>
            <list
                v-if="init"
                :columns="columns"
                :modalCreate="modalCreate"
                :removeLink="removeLink"
                :cardLink="cardLink"
                :params="params"
                :isUpdate="true"
                :isAdd="true"
                :itemLink="itemLink"
                :setLink="setLink"
                :fields="fields"
                :searchDisable="true"
                @change="change"
                @changeFunction="changeFunction"
                v-model="val"
            />
      </card>
    </div>
  </div>
  </div>
  </div>
</template>
<script>
export default {
  props:{
    group_id:{
      default: null
    },
  },
  created() {
      this.itemLink = `business/teacher_groups/${this.group_id}/conferences`;
      this.setLink = `business/teacher_groups/${this.group_id}/conferences`;
  },
  watch:{
    group_id(val){
      this.init = false;
      this.params["page"] = 1;
      this.itemLink = `business/teacher_groups/${val}/conferences`;
      this.setLink = `business/teacher_groups/${val}/conferences`;
      setTimeout(() => {
        this.init = true;
      },10)
    }
  },
  name: "conferences",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      init:true,
      params: {},
      val: [],
      /**START ADD ITEM */
      modalCreate: "conference",
      fields: [
             {
                label: "Время начало",
                key: "start_at",
                type: "datetime",
             },
                {
                key: "title",
                label: "Название",
                type: "field",
                textType: "text",
            },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_conference",
      itemLink: "",
      setLink: "",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          full: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_active",
          title: "Активен",
          checkbox: false,
          full: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
       
        {
          key: "start_at",
          title: "Врмя начало",
          checkbox: false,
          full: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
            dateTimeFormat: true,
        },
       

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
.scroll {
  position:absolute;
  overflow:scroll;
  width:100%;
  height:100%;
}
</style>
